import mutations, {defaultState} from "./mutations";
import getters from "./getters";
import actions from "./actions";

export const namespace = "fnContext";

export const contextStore = (action) => {
    return namespace + "/" + action;
};

export const store_ = {
    namespaced: true,
    state: {...defaultState},
    getters,
    mutations,
    actions
};

export default {
    /**
     * Install the auth store into the app store
     *
     * @param store {{registerModule: function(string,Object)}}
     */
    install: function(store){
        store.registerModule(namespace, store_);
    }
};
